import { LoadScript } from "@react-google-maps/api";
import React, { useContext, useEffect, useState } from "react";
import { GoogleMap, Marker } from '@react-google-maps/api';
import { getMapName } from "../../services/maps-api";
import { getEsHs, getSchoolTypeFromId } from "../../utility/api-utilities";
import { mapStyles } from "../results/map-container-config";
import { AppContext } from "../school-search-app";
import { PAGE_MODE, SCHOOL_TYPE } from "../../interfaces"

// Banner map can probably just be a compare-map with a single school, but finish and figure out what we need firsts
function CompareMap({ schools }) {
    const CHICAGO = { lat: 41.87832960158098, lng: -88.0 }
    const [map, setMap] = useState(null);
    const [center, setCenter] = useState(CHICAGO);
    const [markers, setMarkers] = useState([]);
    const [mapRes, setMapRes] = useState(null)

    const appContext = useContext(AppContext)

    useEffect(() => {
        Promise.all([getMapName('DFSS', 2022, appContext.mode), getMapName('School', 2022, appContext.mode)]).then(res => setMapRes(res))
    }, [])

    useEffect(() => {
        if (!mapRes) {
            return;
        }
        const allFeatures = [...mapRes[0].features, ...mapRes[1].features]
        const checkIds = schools.map(s => '' + s._epi.id);

        const features = allFeatures.filter(s => checkIds.includes(s.properties.School_ID));
        setMarkers(features)
        let bounds = new google.maps.LatLngBounds();
        for (let feature of features) {
            bounds.extend({
                lat: feature.geometry.coordinates[1],
                lng: feature.geometry.coordinates[0]
            });
        }
        if (map) {
            map.fitBounds(bounds);
            if (markers.length === 1) {
                map.setZoom(10)
            }
        }
    }, [schools, mapRes])

    const onLoad = (map) => {
        setMap(map);
    }

    const containerStyle = {
        width: '100%',
        height: '225px'
    };

    let bounds = new google.maps.LatLngBounds();
    for (let feature of markers) {
        bounds.extend({
            lat: feature.geometry.coordinates[1],
            lng: feature.geometry.coordinates[0]
        });
    }

    if (map) {
        map.fitBounds(bounds);
        if (markers.length === 1) {
            map.setZoom(10)
        }
    }

    //const markerKey = appContext.mode == 'cps' ?
    //    `CPS_${getEsHs(school)}`

    const getMarkerKey = (id) => {
        if (appContext.mode == PAGE_MODE.GOCPS) {
            const school = schools.find(s => s._epi.id == id);
            if (school) {
                return `${SCHOOL_TYPE.CPS.toUpperCase() }_${getEsHs(school).toUpperCase()}`
            }
            return SCHOOL_TYPE.CPS.toUpperCase();
        }
        return getSchoolTypeFromId(id) == SCHOOL_TYPE.CEL ? SCHOOL_TYPE.CEL.toUpperCase() : SCHOOL_TYPE.CPS.toUpperCase();
    }

    return mapRes ? <GoogleMap
        mapContainerStyle={containerStyle}
        options={{
            disableDefaultUI: true,
            gestureHandling: "none",
            zoomControl: false,
            styles: mapStyles
        }}

        center={center}
        zoom={14}
        onLoad={onLoad}
    >

        {typeof google !== 'undefined' && markers.map((marker, i) => <Marker
            position={{
                lat: marker.geometry.coordinates[1],
                lng: marker.geometry.coordinates[0]
            }}
            icon={{
                /*url: `/Static-Adage/img/search/GoCPS_${cel ? 'CEL' : 'CPS'}_Map_Marker.svg`,*/
                url: `/Static-Adage/img/search/GoCPS_${getMarkerKey(marker.properties.School_ID)}_Map_Marker.svg`,
                scaledSize: new google.maps.Size(30, 37.5), // scaled size
                origin: new google.maps.Point(0, 0), // origin
                anchor: new google.maps.Point(30, 75) // anchor
            }}
            key={`marker${i}`}
        />)}

    </GoogleMap> : <></>;
}

export default CompareMap
